import React, {  useState } from "react";
import { useFormikContext } from "formik";
import { ErrorMessage } from "formik";
import { Col, InputGroup, Row, CardFooter, } from "reactstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Form } from "formik";
import DefaultButton from "Components/Buttons/DefaultButton";
import { useSchoolsByCommunityId } from "Api/Melder/Export";

registerLocale("nl", nl);
const ExportForm = ({ organizations }) => {

  var date = new Date();
  let setEndDateperiod = date.setMonth(date.getMonth() + 1);

  const formikProps = useFormikContext()
  const [beginDate, setBeginDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date(setEndDateperiod));
  const [communityId, setCommunityId] = useState(
    formikProps.values.organization || null
  );

 const {
    data: schoolsResponse,
    isLoading: schoolsLoading,
    error: schoolsError,
  } = useSchoolsByCommunityId(communityId);

  const schools = schoolsResponse?.data || [];



return (
  <>
    <div className="chat-layout-footer verzoken-footer-height">
      <CardFooter className="d-block d-flex chat-layout-footer__inner">
        <Form className="w-100">
          <div className="align-items-center">
            <Row >
              <Col md="7" >
                <Row >
                  <Col md="2" className="mt-1">
                    <Row className="form-checkbox-styling">
                      <div className="col-md-9 selectBy p-0 ms-2">
                        <select
                          name="organization"
                          value={formikProps.values.organization}
                          className={
                            formikProps.errors.organization && formikProps.touched.organization
                              ? "form-select is-invalid error-export"
                              : "form-select"
                          }
                          onChange={(e) => {
                            const selectedOrgId = e.target.value;
                            setCommunityId(selectedOrgId);
                            formikProps.setFieldValue(
                              "organization",
                              selectedOrgId
                            );
                            formikProps.setFieldValue(
                              "school",
                              ""
                            );
                          }}
                        >
                          <option value="" disabled>
                           Bestuur
                          </option>
                          {
                            organizations.map((org) => (
                              <option key={org.iCommunityId} value={org.iCommunityId}>
                                {org.name}
                              </option>
                            ))}
                        </select>
                        <ErrorMessage
                          name="organization"
                          component="small"
                          className="block mt-2 invalid-feedback"
                        />
                      </div>
                    </Row>
                  </Col>



                  <Col md="2" className="mt-1">
                    <Row className="form-checkbox-styling px-0">
                      <div className="col-md-9 selectBy p-0">
                        <select
                          name="school"
                          value={formikProps.values.school}
                          className="form-select"
                          
                          onChange={(e) => {
                            const selectedSchoolId = e.target.value;
                            formikProps.setFieldValue("school", selectedSchoolId);
                          }}
                        >
                          <option value="" disabled>
                           School
                          </option>
                          {schools &&
                            schools.map((school) => (
                              <option key={school.iSchoolId} value={school.iSchoolId}>
                                {school.vSchoolName}
                              </option>
                            ))}
                        </select>
                        <ErrorMessage
                          name="school"
                          component="small"
                          className="block mt-2 invalid-feedback"
                        />
                      </div>
                    </Row>
                  </Col>

                  <Col md="3" className="mt-1">
                    <Row className="form-checkbox-styling px-0">
                      <div className="filterBy col-md-3 p-0 d-flex align-items-center justify-content-end">
                        <label className="mb-0 mx-2">Begindatum</label>
                      </div>
                      <div className="col-md-8 selectBy p-0">
                        <InputGroup>
                          <div className="customDatePicker" >
                            <DatePicker
                              locale="nl"
                              selected={beginDate}
                              className=" form-control"
                              onChange={(date) => {
                                setBeginDate(date);
                                formikProps.setFieldValue("dateBeginPeriod", date);
                              }}
                              selectsStart
                              name="dateBeginPeriod"
                              dateFormat="dd-MM-yyyy"
                            />
                            <ErrorMessage
                              name="dateBeginPeriod"
                              component="small"
                              className="block mt-2 invalid-feedback"
                            />
                            <FontAwesomeIcon
                              icon={faCalendarAlt}
                              className="datepicker-icon-FontAwesome "
                            />
                          </div>
                        </InputGroup>
                      </div>
                    </Row>
                  </Col>

                  <Col md="3" className="mt-1">
                    <Row className="form-checkbox-styling px-0">
                      <div className="filterBy col-md-3 p-0 d-flex align-items-center justify-content-end">
                        <label className="mb-0 mx-2">Einddatum</label>
                      </div>
                      <div className="col-md-8 selectBy p-0">
                        <InputGroup>
                          <div className="customDatePicker" >
                            <DatePicker
                              locale="nl"
                              selected={endDate}
                              className=" form-control"
                              onChange={(date) => {
                                setEndDate(date);
                                formikProps.setFieldValue("dateEndPeriod", date);
                              }}
                              selectsEnd
                              startDate={beginDate}
                              endDate={endDate}
                              minDate={beginDate}
                              name="dateEndPeriod"
                              dateFormat="dd-MM-yyyy"
                            />
                            <ErrorMessage
                              name="dateEndPeriod"
                              component="small"
                              className="block mt-2 invalid-feedback"
                            />
                            <FontAwesomeIcon
                              icon={faCalendarAlt}
                              className="datepicker-icon-FontAwesome"
                            />
                          </div>
                        </InputGroup>
                      </div>
                    </Row>
                  </Col>


                </Row>
              </Col>

              <Col md="5" className="d-flex  justify-content-end "  style={{ height: "fit-content" }}>
                <DefaultButton className="mb-2 me-0 btn-color-style" type="submit">
                  Export samenstellen
                </DefaultButton>
              </Col>
            </Row>

          </div>


        </Form>
      </CardFooter>
    </div>
  </>
)
}

export default ExportForm;

